import { useQuery } from "@tanstack/react-query"
import api from "@/lib/api"

export type RegistrationMode = "public" | "invite" | "admin_approve"

export interface RegistrationConfigResponse {
  mode: RegistrationMode
  security_phrase_required: boolean
  security_phrase_label: string
  require_email_verification?: boolean
  allow_public_signup: boolean
  require_referral_code: boolean
  allow_admin_invite_only: boolean
}

export function useRegistrationConfig() {
  return useQuery({
    queryKey: ["auth-registration-config"],
    queryFn: async () => {
      const res = await api.get<RegistrationConfigResponse>("/auth/registration-config")
      return res.data
    },
    staleTime: 60 * 1000,
  })
}
